/** Session helpers for the embedded Manage area (sessionStorage). */

export function parseJsonArray(raw) {
  if (!raw) return []
  try {
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

export function isLoggedIn() {
  return Boolean(sessionStorage.getItem('id'))
}

export function getPermissions() {
  return parseJsonArray(sessionStorage.getItem('permissions'))
}

export function canAccessAdminFlag() {
  const flag = sessionStorage.getItem('can_access_admin')
  return flag === '1' || flag === 'true'
}

/** Role id 1 (Administrator) sees every module. */
export function hasFullAdminAccess() {
  const role = String(sessionStorage.getItem('user_role') || '')
  if (role === '1') return true
  const roleIds = parseJsonArray(sessionStorage.getItem('role_ids'))
  return roleIds.some((id) => Number(id) === 1)
}

/** Can open Manage shell at all. */
export function canAccessManage() {
  if (!isLoggedIn()) return false
  // Administrator (role id 1) always has Manage, even if permissions array is empty
  // or can_access_admin was missing from an older login payload.
  if (hasFullAdminAccess()) return true
  if (canAccessAdminFlag()) return true
  return getPermissions().length > 0
}

export function hasModule(moduleKey) {
  if (!moduleKey) return canAccessManage()
  if (hasFullAdminAccess()) return true
  return getPermissions().includes(moduleKey)
}
